import {Lightbox} from "../../../classes/Lightbox";

export const initSectionContacts = ( mapNode, ymapsMap, ymapsObjectManager ) => {
	const component = mapNode.closest(`section.contacts`);

	if ( component )
	{
		const toggle = component.querySelector(`div.offices div.toggle`);
		const officesList = component.querySelector(`div.offices aside ul`);
		let prevButton = toggle.querySelector(`button`);

		toggle.addEventListener(`click`, ({target}) => {
            const button = target.closest(`button`);

            if ( button )
            {
                button.classList.contains(`map`) ? officesList.closest(`div.offices`).classList.add(`show-map`) : officesList.closest(`div.offices`).classList.remove(`show-map`);

                button.classList.add(`current`);
                prevButton.classList.remove(`current`);
                prevButton = button;
            }
        });

		officesList.addEventListener(`click`, ({target}) => {
            if ( !target.closest(`li.head`) )
            {
                const listItem = target.closest(`li`);
				const isAnimated = listItem.classList.contains(`animated`);
				const buttonBack = target.closest(`button.back`);

				if ( !isAnimated && !buttonBack )
				{
					listItem.classList.remove(`animated`);
					const marker = ymapsObjectManager.objects.getAll().find((item) => listItem.getAttribute(`data-latitude`) === item.geometry.coordinates[0] && listItem.getAttribute(`data-longitude`) === item.geometry.coordinates[1]);
					const [latitude, longitude] = marker.geometry.coordinates;
					ymapsMap.panTo([parseFloat(latitude), parseFloat(longitude)], {
						checkZoomRange: true,
					});
				}
            }
        });

		ymapsObjectManager.events.add( `click`, (evt) => {
			const marker = evt.get('target').getById(evt.get('objectId'));

			if ( marker )
			{
				const [latitude, longitude] = marker.getData().geometry.coordinates;
				const listItem = [...officesList.children].find((item) => item.getAttribute(`data-latitude`) === latitude && item.getAttribute(`data-longitude`) === longitude);

				if ( window.innerWidth >= 956 )
				{
					const current = officesList.querySelector(`li.current`);

					officesList.classList.add(`show-office`);
					listItem.classList.add(`current`);

					
					if ( current && current !== listItem )
					{
						current.classList.remove(`current`); 
					}	
				} else
				{
					setTimeout( () => {
						Lightbox.open(listItem.innerHTML, null, `tooltip`);

                    const contentWrapper = Lightbox.getLightbox().querySelector(`div.wrapper`);
							let wasStarted = false;
							let isDetecting = false;
							let startX;
							let moveX;
							let prevShiftY;
							let shiftY;
							let startY;
							let moveY;
							
							const moveWrapper = ( moveEvt ) => {
								if ( !wasStarted && !isDetecting )
								{
									return;
								}

								moveX = moveEvt.touches[0].clientX;
								moveY = moveEvt.touches[0].clientY;

								if ( isDetecting )
								{
									if ( Math.abs(startX - moveX) <= Math.abs(startY - moveY) )
									{
										moveEvt.preventDefault();

										wasStarted = true;
									}

									isDetecting = false;
								}

								if ( wasStarted )
								{
									moveEvt.preventDefault();

									prevShiftY = shiftY;
									shiftY = (moveY - startY) * 100 / contentWrapper.offsetHeight;
									contentWrapper.style.transition = `none`;
									contentWrapper.style.transform = `translateY(${shiftY < 0 ? 0 : shiftY}%)`;
								}
							};
							const endMoveWrapper = ( endEvt ) => {
								if ( !wasStarted || isDetecting )
								{
									return isDetecting = false;
								}

								endEvt.preventDefault();
								wasStarted = false;

								contentWrapper.style.transition = ``;

								if ( prevShiftY < shiftY )
								{
									contentWrapper.style.transform = `translateY(100%)`;
									Lightbox.close();
								} else
								{
									contentWrapper.style.transform = ``;
								}
							};

							Lightbox.addCloseCallback( () => {
								document.removeEventListener(`touchmove`, moveWrapper);
								document.removeEventListener(`touchend`, endMoveWrapper);
							});
							
							contentWrapper.addEventListener(`touchstart`, ( startEvt ) => {
								if ( wasStarted )
								{
									return;
								}

								isDetecting = true;

								startX = startEvt.touches[0].clientX;
								startY = startEvt.touches[0].clientY;
							});
							document.addEventListener(`touchmove`, moveWrapper, {passive: false});
							document.addEventListener(`touchend`, endMoveWrapper, {passive: false});
					}, 10);
				}

				ymapsMap.panTo([parseFloat(latitude), parseFloat(longitude)], {
					checkZoomRange: true,
				});
			}
		});
		
		ymapsMap.setCenter([59.926398, 30.411581]);
	}
};
